module.exports = __webpack_public_path__ + "static/media/corpBanner2.adbc3855.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/corpBanner2.jpg
// module id = 359
// module chunks = 0